import { CheckIcon } from "@chakra-ui/icons";
import {
  Box,
  Center,
  Flex,
  Heading,
  Spacer,
  Text,
  VStack,
} from "@chakra-ui/react";

const OrderCompleted = () => {
  return (
    <Box pt="3" px="6" pb="6">
      {/* Header title / premium notice */}
      <Flex>
        <Text fontSize="sm" color="gray.400" mb="2">
          UP NEXT
        </Text>
        <Spacer />
      </Flex>
      {/* Main content */}
      <Center>
        <VStack>
          <Heading as="h4" size="md">
            <CheckIcon color="green.500" /> Reading completed
          </Heading>
          <Text>Amazing job, you've read it all!</Text>
        </VStack>
      </Center>
    </Box>
  );
};

export default OrderCompleted;
